export default __webpack_public_path__ + "static/media/archive-session-cancelled.617093fc.svg";